import type { IconData } from '@stacksjs/iconify-core'

export const sofa: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M448 242.025V152a48.055 48.055 0 0 0-48-48H112a48.055 48.055 0 0 0-48 48v90.025A64.115 64.115 0 0 0 16 304v112a32.036 32.036 0 0 0 32 32h16v48h32v-48h320v48h32v-48h16a32.036 32.036 0 0 0 32-32V304a64.115 64.115 0 0 0-48-61.975M112 416H48V304a32 32 0 0 1 64 0Zm256 0H144v-96h224Zm2.025-128h-228.05A64.24 64.24 0 0 0 96 242.025V152a16.02 16.02 0 0 1 16-16h288a16.02 16.02 0 0 1 16 16v90.025A64.24 64.24 0 0 0 370.025 288M464 416h-64V304a32 32 0 0 1 64 0l.02 112Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sofa
